export default __webpack_public_path__ + "static/media/position.d198d4da.svg";